import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImageWebp from './images/all-cultures-desktop.webp';
import financialPlanningMobileImageWebp from './images/all-cultures-mobile.webp';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='recruitment-campaign-financial-planning-section-2'
      backgroundVariant='lightA'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent
      // content
      subHeadingText={<>A culture <WidowBlock>of support</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography disableBottomPadding>
            Many Northwestern Mutual financial advisors didn&#39;t start out in the financial industry&#8212;the unique background they bring is what helps them succeed in their business, with their clients, and in their communities. Here&#39;s how we support and build a culture of success:
          </Typography>
          <BulletedList
            bulletType='checkmark'
            bulletedListData={[
              { bulletText: (<><strong>The Women&#39;s Field Association of Northwestern Mutual</strong> is over 2,200 members strong and was built by women to advance women in all roles.</>) },
              { bulletText: (<>Northwestern Mutual is dedicated to helping <strong>close the racial wealth gap</strong> through initiatives like our &#36;100 million Impact Investing Fund to support Black communities nationally and locally and our Black Founder Accelerator program powered by gener8tor.</>) },
              { bulletText: (<>You&#39;ll have the opportunity to pursue <strong>advanced professional certifications</strong> with financial support, mentorships, joint work opportunities, and more.</>) },
              { bulletText: (<><strong>Community support</strong> is a key part of our culture. Our offices across the country work with nonprofits to create real impact nationally, and in our neighborhoods.</>) },
            ]}
          />
        </>
      )}
      // image props
      imageAltText='A culturally diverse group of business professionals.'
      imageSrcDefault={financialPlanningImageWebp.toString()}
      imageSrcMobile={financialPlanningMobileImageWebp.toString()}
    />
  );
};

